import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { getConsentFromDocument } from '#app/utils/consent.ts'

export function useAnalyticsPageview() {
	const location = useLocation()
	const isFirstRender = useRef(true)

	useEffect(() => {
		// Skip initial render - PostHog captures that on init
		if (isFirstRender.current) {
			isFirstRender.current = false
			return
		}

		if (getConsentFromDocument() !== 'granted') return
		if (!ENV.POSTHOG_API_KEY) return

		void import('#app/utils/analytics.client.tsx').then(({ capturePageview }) =>
			capturePageview(),
		)
	}, [location.pathname, location.search])
}
